module.exports = __webpack_public_path__ + "static/img/icon-new.34b74259.svg";